/** 过滤神策业务属性的既有空值；只复制顶层，不改写输入或嵌套业务字段。 */
export function filterSensorsBusinessProperties(
  properties: Record<string, unknown>,
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(properties).filter(
      ([, value]) =>
        value !== '' &&
        value !== 'null' &&
        value !== 'undefined' &&
        value != null &&
        !(Array.isArray(value) && value.length === 0),
    ),
  );
}
